if (!customElements.get('mandl-hero-carousel')) {
  customElements.define(
    'mandl-hero-carousel',
    class MandlHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.mandl-carousel__slide'));
        this.dots = Array.from(this.querySelectorAll('.mandl-carousel__dot'));
        this.currentIndex = 0;
        this.autoAdvanceDelay = parseInt(this.dataset.delay, 10) || 4000;
        this.timer = null;

        this.querySelector('.mandl-carousel__arrow--prev')
          ?.addEventListener('click', () => { this.prev(); this.resetTimer(); });
        this.querySelector('.mandl-carousel__arrow--next')
          ?.addEventListener('click', () => { this.next(); this.resetTimer(); });

        this.dots.forEach((dot, i) =>
          dot.addEventListener('click', () => { this.goTo(i); this.resetTimer(); })
        );

        this.addEventListener('mouseenter', () => this.stopTimer());
        this.addEventListener('mouseleave', () => this.startTimer());

        // Keyboard support
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { this.prev(); this.resetTimer(); }
          if (e.key === 'ArrowRight') { this.next(); this.resetTimer(); }
        });

        this.goTo(0);
        if (this.slides.length > 1) this.startTimer();
      }

      disconnectedCallback() {
        this.stopTimer();
      }

      goTo(index) {
        this.slides[this.currentIndex]?.classList.remove('is-active');
        this.dots[this.currentIndex]?.classList.remove('is-active');

        this.currentIndex = ((index % this.slides.length) + this.slides.length) % this.slides.length;

        this.slides[this.currentIndex]?.classList.add('is-active');
        this.dots[this.currentIndex]?.classList.add('is-active');
      }

      next() { this.goTo(this.currentIndex + 1); }
      prev() { this.goTo(this.currentIndex - 1); }

      startTimer() {
        this.stopTimer();
        this.timer = setInterval(() => this.next(), this.autoAdvanceDelay);
      }

      stopTimer() {
        clearInterval(this.timer);
        this.timer = null;
      }

      resetTimer() {
        if (this.slides.length > 1) this.startTimer();
      }
    }
  );
}
